<template>
  <div class="content">
    <div class="title-label">
      <span>量表列表</span>
      <div>
        <axe-button
          type="primary"
          size="small"
          @click="issue(2)"
        >
          创建任务
        </axe-button>
      </div>
    </div>

    <div class="content-box">
      <axe-form
        :inline="true"
        :model="formInline"
      >
        <axe-form-item label="适用学段">
          <axe-select
            v-model="formInline.segmentCode"
            class="w140"
            placeholder="请选择"
            size="small"
            @change="getData(true)"
          >
            <axe-option
              label="全部"
              value=""
            />
            <axe-option
              v-for="(it, index) in phaseList"
              :key="index"
              :label="it.name"
              :value="it.code"
            />
          </axe-select>
        </axe-form-item>
        <!-- 区级只能看心理健康 则不显示所属模块 -->
        <axe-form-item label="所属模块">
          <axe-select
            v-model="formInline.gaugeModuleCode"
            class="w140"
            placeholder="请选择"
            size="small"
            @change="listGaugeType"
          >
            <axe-option
              label="全部"
              value=""
            />
            <axe-option
              v-for="(it, index) in modelList"
              :key="index"
              :label="it.name"
              :value="it.value"
            />
          </axe-select>
        </axe-form-item>
        <axe-form-item label="量表类型">
          <axe-select
            v-model="formInline.gaugeTypeId"
            class="w140"
            placeholder="请选择"
            size="small"
            @change="getData(true)"
          >
            <axe-option
              label="全部"
              value=""
            />
            <axe-option
              v-for="(it, index) in typeList"
              :key="index"
              :label="it.gaugeTypeName"
              :value="it.businessId"
            />
          </axe-select>
        </axe-form-item>
        <axe-form-item label="">
          <axe-input
            v-model="formInline.gaugeName"
            class="w185"
            size="small"
            placeholder="请输入量表名称"
            @keyup.enter.native="getData(true)"
          >
            <span
              slot="suffix"
              class="icon"
              @click="getData(true)"
            ><i class="el-input__icon el-icon-search" /></span>
          </axe-input>
        </axe-form-item>
      </axe-form>
      <div
        v-show="listData.length"
        class="lists"
      >
        <div
          v-for="(it, index) in listData"
          :key="index"
          class="list-item"
        >
          <div @click="clickDetail(it)">
            <div class="title-icon">
              <span class="all">{{ it.segmentName }}</span>
            </div>

            <div class="imgbox">
              <img
                class="item-img"
                :src="it.gaugeIcon"
                alt=""
              >
              <div class="title-icon-right">
                <span class="">{{ it.gaugeModuleType }}</span>
              </div>
            </div>

            <div class="img-text">
              <div class="img-text-title">
                {{ it.gaugeName }}
              </div>
            </div>
            <div class="title ellipsis">
              {{ it.gaugeName }}
            </div>
            <div class="title-cont">
              {{ it.gaugeDesc }}
            </div>
          </div>
          <div class="button">
            <!-- id 6 学会沟通 7 考试焦虑 -->
            <axe-button
              class="priamry"
              type="primary"
              size="small"
              @click="issue(1, it)"
            >
              发布
            </axe-button>
          </div>
        </div>
      </div>
      <div
        v-show="listData.length === 0 && resquestEnd"
        class="jyxq-no-data"
      >
        <img
          src="@/assets/images/no-search.png"
          alt=""
        >
        <div>暂无搜索结果</div>
      </div>
      <pagination
        v-show="listData.length"
        ref="pageNation"
        :page-size="page.pageSize"
        :page-num="page.pageNum"
        :total="total"
        @handleCurrent="handleCurrent"
      />
    </div>
  </div>
</template>

<script>
import pagination from "@/components/pagination";

export default {
  components: { pagination },
  props: {},
  data () {
    const query = this.$route.query;;

    return {
      formInline: {
        segmentCode: "", // 适用学段
        gaugeModuleCode: "", // 所属模块 心理健康@01  心理发展@02  @生涯发展:03
        gaugeTypeId: "", // 量表类型
        gaugeName: "", // 量表名称
      },
      phaseList: [
        { "code": "05", "name": "高中", "children": null },
        { "code": "04", "name": "初中", "children": null },
        { "code": "03", "name": "小学", "children": null }
      ], // 03 小学 04 初中 05 高中
      modelList: [
        { "name": "心理健康", "value": "01" },
        { "name": "心理发展", "value": "02" },
        { "name": "生涯发展", "value": "03" }],
      typeList: [],
      listData: [],
      resquestEnd: false,
      total: 0,
      page: {
        pageNum: query.pageNo ? Number(query.pageNo) : 1,
        pageSize: 12,
      },
      allList: [],
    };
  },
  filters: {
    filterType (val) {

      let filterData = this.typeList.filter(item => {
        return item.id === 1;
      })
    },
  },
  computed: {

  },
  watch: {},
  created () {
    // 区级只有心理健康
    this.listGaugeTypeByGaugeModule();
    this.getData();
  },
  mounted () {

  },
  methods: {
    listGaugeType () {
      this.formInline.gaugeTypeId = '';
      this.getData(true);
      this.listGaugeTypeByGaugeModule();
    },
    listGaugeTypeByGaugeModule () {
      this.typeList = [
        {
          "id": 28,
          "businessId": "44d61ffa915447c8a997fe343675b52c",
          "gaugeTypeName": "健康与卫生",
          "gaugeTypeCode": null,
          "gaugeModuleCode": "01",
          "remark": "健康啊，你健康么",
          "modifyTime": "2022-01-11T09:16:09.000+00:00"
        },
        {
          "id": 30,
          "businessId": "140e495ab1dd49b2b4b2a8397ca82697",
          "gaugeTypeName": "认识自我11",
          "gaugeTypeCode": null,
          "gaugeModuleCode": "01",
          "remark": "认识自我11",
          "modifyTime": "2022-01-17T00:22:34.000+00:00"
        },
        {
          "id": 35,
          "businessId": "b2c17fe570f84f5b9594b797d62b1c3e",
          "gaugeTypeName": "心理健康011--",
          "gaugeTypeCode": null,
          "gaugeModuleCode": "01",
          "remark": "心理健康量表011--",
          "modifyTime": "2021-12-23T06:20:37.000+00:00"
        },
        {
          "id": 37,
          "businessId": "39181396a3f349eb9dd482d0320a89b6",
          "gaugeTypeName": "人际交往",
          "gaugeTypeCode": null,
          "gaugeModuleCode": "02",
          "remark": "主题测评中的人际交往",
          "modifyTime": "2021-12-22T08:36:22.000+00:00"
        },
        {
          "id": 55,
          "businessId": "eecfc8a464c241449e1b02e98ad5037a",
          "gaugeTypeName": "情绪发展",
          "gaugeTypeCode": null,
          "gaugeModuleCode": "02",
          "remark": "情绪发展与调节",
          "modifyTime": "2021-12-29T16:51:25.000+00:00"
        },
        {
          "id": 57,
          "businessId": "cff8591f40054cba839a263f4de35c33",
          "gaugeTypeName": "心理健康测试",
          "gaugeTypeCode": null,
          "gaugeModuleCode": "01",
          "remark": "心理健康类型测试",
          "modifyTime": "2022-01-11T08:35:09.000+00:00"
        },
        {
          "id": 58,
          "businessId": "4553cc5a3af64cdba7c49fada8c03a7d",
          "gaugeTypeName": "测试心理健康类",
          "gaugeTypeCode": null,
          "gaugeModuleCode": "01",
          "remark": "11",
          "modifyTime": "2022-01-13T12:18:11.000+00:00"
        },
        {
          "id": 59,
          "businessId": "a931c8881f7743ad946c22ab48ff82f5",
          "gaugeTypeName": "涂艳沁类型",
          "gaugeTypeCode": null,
          "gaugeModuleCode": "01",
          "remark": "111",
          "modifyTime": "2022-01-17T02:52:27.000+00:00"
        },
        {
          "id": 63,
          "businessId": "2a581933036442a8ba04d5d9e13671a0",
          "gaugeTypeName": "1测试心理健康类型@",
          "gaugeTypeCode": null,
          "gaugeModuleCode": "01",
          "remark": "1测试心理健康类型说明",
          "modifyTime": "2022-02-28T08:11:52.000+00:00"
        },
        {
          "id": 66,
          "businessId": "697fb0e55e3c4dddb6f87f5988600edd",
          "gaugeTypeName": "郑方磊心理健康误删",
          "gaugeTypeCode": null,
          "gaugeModuleCode": "01",
          "remark": "郑方磊心理健康类型说明",
          "modifyTime": "2022-01-18T06:23:54.000+00:00"
        },
        {
          "id": 76,
          "businessId": "fcf56f2573244742946587463fe9073d",
          "gaugeTypeName": "学会学习",
          "gaugeTypeCode": null,
          "gaugeModuleCode": "02",
          "remark": "特殊类型6",
          "modifyTime": "2022-01-20T05:54:06.000+00:00"
        },
        {
          "id": 77,
          "businessId": "418a8f963b4446f9a306a4adc4b68c01",
          "gaugeTypeName": "升学择业",
          "gaugeTypeCode": null,
          "gaugeModuleCode": "02",
          "remark": "特殊类型5",
          "modifyTime": "2022-01-20T05:53:59.000+00:00"
        },
        {
          "id": 78,
          "businessId": "45e5e79ea1b04bc9a95a7fff73b1a715",
          "gaugeTypeName": "社会与适应",
          "gaugeTypeCode": null,
          "gaugeModuleCode": "02",
          "remark": "特殊类型4",
          "modifyTime": "2022-01-20T05:53:51.000+00:00"
        },
        {
          "id": 79,
          "businessId": "b5f13beb30df4456ba44edc3c36feabf",
          "gaugeTypeName": "情绪发展",
          "gaugeTypeCode": null,
          "gaugeModuleCode": "02",
          "remark": "特殊类型3",
          "modifyTime": "2022-01-20T05:53:41.000+00:00"
        },
        {
          "id": 80,
          "businessId": "3eeb9eefbab74c4ab5ffd8d28e6543cc",
          "gaugeTypeName": "人际交往",
          "gaugeTypeCode": null,
          "gaugeModuleCode": "02",
          "remark": "特殊类型2",
          "modifyTime": "2022-01-20T05:53:36.000+00:00"
        },
        {
          "id": 81,
          "businessId": "910c40bb97ae4979a5736873940be548",
          "gaugeTypeName": "认识自我",
          "gaugeTypeCode": null,
          "gaugeModuleCode": "02",
          "remark": "特殊类型1",
          "modifyTime": "2022-01-20T05:53:30.000+00:00"
        },
        {
          "id": 82,
          "businessId": "0566e065835e4321a335a3d9b952e908",
          "gaugeTypeName": "这是一个很好的量表",
          "gaugeTypeCode": null,
          "gaugeModuleCode": "01",
          "remark": "这是一个很好的量表",
          "modifyTime": "2022-04-26T03:19:09.000+00:00"
        },
        {
          "id": 84,
          "businessId": "05b03bfd55d74ccdb8bce9c46c4e0189",
          "gaugeTypeName": "心理健康-类型cs",
          "gaugeTypeCode": null,
          "gaugeModuleCode": "01",
          "remark": "类型说明cs",
          "modifyTime": "2022-03-10T01:28:20.000+00:00"
        },
        {
          "id": 85,
          "businessId": "10b265b6f763478d8825108429cee25d",
          "gaugeTypeName": "生涯规划",
          "gaugeTypeCode": null,
          "gaugeModuleCode": "03",
          "remark": "生涯规划类型",
          "modifyTime": "2022-03-08T05:38:38.000+00:00"
        },
        {
          "id": 86,
          "businessId": "ba4af42c0a414867bb297aac7b070823",
          "gaugeTypeName": "学会学习1",
          "gaugeTypeCode": null,
          "gaugeModuleCode": "02",
          "remark": "1111111",
          "modifyTime": "2022-03-11T02:16:14.000+00:00"
        },
        {
          "id": 100,
          "businessId": "083f3313797b40de85bb7a235dc43cab",
          "gaugeTypeName": "学会学习1",
          "gaugeTypeCode": null,
          "gaugeModuleCode": "01",
          "remark": "11",
          "modifyTime": "2022-03-13T06:06:09.000+00:00"
        },
        {
          "id": 101,
          "businessId": "9313fdef4ff0484289e36d9aea4fc5fa",
          "gaugeTypeName": "心理健康",
          "gaugeTypeCode": null,
          "gaugeModuleCode": "01",
          "remark": "心理健康量表",
          "modifyTime": "2022-03-25T06:49:09.000+00:00"
        },
        {
          "id": 106,
          "businessId": "1478619204686464",
          "gaugeTypeName": "1111",
          "gaugeTypeCode": null,
          "gaugeModuleCode": "01",
          "remark": "1111111111",
          "modifyTime": "2022-04-29T02:12:57.000+00:00"
        },
        {
          "id": 108,
          "businessId": "1495364622964416",
          "gaugeTypeName": "四月29日",
          "gaugeTypeCode": null,
          "gaugeModuleCode": "01",
          "remark": "这是一个测试量表类型",
          "modifyTime": "2022-05-06T05:56:28.000+00:00"
        }
      ];
    },
    getData (val) {
      var res = {
        "pageNo": 1,
        "pageSize": 12,
        "totalCount": 36,
        "dataList": [
          {
            "segmentName": "初中、小学、高中",
            "gaugeModuleCode": "01",
            "gaugeName": "心理健康诊断测验",
            "gaugeId": "a79301087b994d6f8915ba7f60e23ed1",
            "id": null,
            "gaugeDesc": "中学生心理健康诊断测验(MHT)是由华东师范大学心理学系教授周步成和其他心理学科研究人员,根据日本铃木清等人编制的\"不安倾向诊断测验\"进行修订，成为适应于我国中学学生标准化的《心理健康诊断测验》，本量表从学习焦虑、对人焦虑、孤独倾向、自责倾向、过敏倾向、身体症状、恐怖倾向、冲动倾向8个方面评估学生的心理状态，并通过效度量表评估学生在回答问题过程中是否有掩盖自己真实想法的行为。本量表共100题，学生完成时间约需30分钟。",
            "gaugeIcon": "https://test.download.cycore.cn/CSB-decompression-planet-service/1427d073-42f7-44d9-9133-8308b73ac744/编组14(3).png",
            "gaugeModuleType": "健康与卫生",
          },
          {
            "segmentName": "初中、小学、高中",
            "gaugeModuleCode": "02",
            "gaugeName": "压力状态评估",
            "gaugeId": "2b3a1a0b5d634d8590cc2e57a061dfb7",
            "id": null,
            "gaugeDesc": "《中小学生压力状况评估》由科大讯飞生涯与心理健康教研中心主导研发，测评聚焦当前中小学生成长发展过程中最为常见的问题方面，以了解学生压力来源及压力感受为目的编制，旨在帮助教师更加了解学生当前生活状态，为学生定制更具针对性的帮助方案。\n本测评主要从学生学习状况、人际交往、自我意识、健康状况及应对方式五大方面入手，共40道题目，全面了解学生学习与生活状态，对其压力状况进行评估。",
            "gaugeIcon": "https://bj.download.cycore.cn/CSB-decompression-planet-service/d063c3da-d496-4026-8f52-37671127a0cd/编组14(2).png",
            "gaugeModuleType": "社会与适应",
          },
          {
            "segmentName": "初中、小学、高中",
            "gaugeModuleCode": "02",
            "gaugeName": "积极心理品质量表",
            "gaugeId": "0350fa2542c043fab5f3467bc83ee169",
            "id": null,
            "gaugeDesc": "《中国中小学生积极心理品质量表》是由我国学者孟万金等人以积极行为分类评价系统和性格优势为理论基础，借鉴VIA-Youth并参考诸多文献分析结果，历时7年通过对1600名（有效数据1316人）被试的测量进行编制的。该量表由六个分量表组成共61道题目，统计检验表明具有良好的信效度。可测量中国中小学生六大维度的15项积极品质，也可用于大规模测评中国中小学生积极心理品质发展状况。",
            "gaugeIcon": "https://bj.download.cycore.cn/CSB-decompression-planet-service/03b70af4-2ac5-4aba-ae27-1f2a05724ee6/编组14.png",
            "gaugeModuleType": "认识自我",
          },
          {
            "segmentName": "初中,高中",
            "gaugeModuleCode": "02",
            "gaugeName": "亲子关系问卷",
            "gaugeId": "d148977487d64e8191ca5dbaa207c175",
            "id": null,
            "gaugeDesc": "《中学生亲子关系问卷》由西南大学吴继霞、黄希庭等编制，符合中国人的特征，从“亲”和“子”两个角度设计问卷，进行比较，更具有现实意义。本问卷可以较为客观地评估中学生的亲子关系，以便改进亲子关系。以访谈和文献研究为基础确定维度、形成问卷，预测试和施测之后，通过探索性因素分析及验证性因素分析进行题项筛选,最终确定《中学生亲子关系问卷》(共26题）由四个维度组成，且具有较高的信效度。",
            "gaugeIcon": "https://bj.download.cycore.cn/CSB-decompression-planet-service/ac82a0ef-a569-4ce4-be88-c336ad8dcccd/编组14(1).png",
            "gaugeModuleType": "人际交往",
          },
          {
            "segmentName": "初中、小学、高中",
            "gaugeModuleCode": "02",
            "gaugeName": "网络成瘾",
            "gaugeId": "b4a4e4f2aa974dbe9796347aee840da4",
            "id": null,
            "gaugeDesc": "本量表从网络耐受性、强迫性上网行为、网络引起的时间管理问题和人际与健康问题四个维度评估学生的网络成瘾程度，量表中所有题目选项均为5点量表，总分越高说明学生的网络成瘾程度越强。",
            "gaugeIcon": "https://test.download.cycore.cn/CSB-decompression-planet-service/09a1e16b-af96-4251-bda6-4fbe61b503f6/编组16(2).png",
            "gaugeModuleType": "社会与适应",
          },
          {
            "segmentName": "初中、小学、高中",
            "gaugeModuleCode": "02",
            "gaugeName": "考试焦虑",
            "gaugeId": "2d8b80ecffb648dbb78a64c9b7fd56da",
            "id": null,
            "gaugeDesc": "本量表评估学生的考试焦虑程度，量表中所有题目选项均为5点量表，总分越高说明学生的考试焦虑越强",
            "gaugeIcon": "https://test.download.cycore.cn/CSB-decompression-planet-service/ccb0c1e6-f6de-41c0-ab75-203714c9b69f/编组14(5).png",
            "gaugeModuleType": "学会学习",
          },
          {
            "segmentName": "初中、高中",
            "gaugeModuleCode": "01",
            "gaugeName": "PHQ-9 抑郁自评量表",
            "gaugeId": "d7c23a47e46549f084aa7fb5de3abbd5",
            "id": null,
            "gaugeDesc": "抑郁自评量表（PHQ-9）是一个简便、有效的抑郁自评量表，在抑郁症诊断的辅助和症状严重程度评估方面，均具有良好的信度和效度。PHQ-9因简单易懂，操作方便，易掌握等优点近年广泛应用于临床，是国际通用抑郁检测量表之一，也是国家卫健委官网发布的《探索抑郁症防治特色服务工作方案》中指定的抑郁症筛查量表。但此量表仅用于筛查，不能作为诊断的依据，请老师慎重使用。本量表共9道题，学生完成时间约需5分钟。",
            "gaugeIcon": "https://test.download.cycore.cn/CSB-decompression-planet-service/bf3981a5-85a7-45bf-8c93-b8f93a1e09c8/编组16@2x(3).png",
            "gaugeModuleType": "健康与卫生",
          },

          {
            "segmentName": "高中",
            "gaugeModuleCode": "01",
            "gaugeName": "症状自评量表（SCL-90）",
            "gaugeId": "2917a3921a2f4320bcee6a9890a3cd06",
            "id": null,
            "gaugeDesc": "SCL--90症状自评表是世界上最著名的心理健康测试量表之一，有容量大、反映症状丰富，更能准确刻画受测者的自觉症状特性等优点。该量表共有90个项目，包括躯体化、强迫症状、人际关系敏感、抑郁、焦虑、敌对、恐怖、偏执、精神病性等维度。本量表共90题，学生完成时间约需30分钟。",
            "gaugeIcon": "https://test.download.cycore.cn/CSB-decompression-planet-service/2b29962b-ef2c-41e3-afb7-9fb23920fb9e/编组14(4).png",
            "gaugeModuleType": "健康与卫生",
          },
          {
            "segmentName": "初中、高中",
            "gaugeModuleCode": "01",
            "gaugeName": "流调中心抑郁量表(CES-D)",
            "gaugeId": "91e2f7b2ed6241c19ccae55cf2bf497a",
            "id": null,
            "gaugeDesc": "《流调中心抑郁量表(CES-D)》是美国国立精神卫生研究院Radloff于1977年编制的，最初是为了研究抑郁症状的相关因素以及发展规律、特别为评价当前抑郁症状的频度而设计的，是适合关注学生抑郁情感或心境的量表工具，具有很高的信度和效度。本测验为教师了解学生心理健康并进行心理辅导提供帮助。",
            "gaugeIcon": "https://bj.download.cycore.cn/CSB-decompression-planet-service/ac82a0ef-a569-4ce4-be88-c336ad8dcccd/编组14(1).png",
            "gaugeModuleType": "健康与卫生",
          },
          {
            "segmentName": "高中",
            "gaugeModuleCode": "01",
            "gaugeName": "疲劳量表",
            "gaugeId": "f45b0c08bc6d486aaad25221190fe211",
            "id": null,
            "gaugeDesc": "《疲劳量表-14》（FS-14）是由英国的Trudie Chalder及G. Berelowitz等专家于1992年共同编制的。疲劳一直是一个很难定义与描述的症状，尤其是疲劳的主观感觉方面。该量表可以有效测定疲劳症状的严重程度，评估临床疗效，以及在流行病学研究中筛选疲劳病例。该量表适用于高中生，测验用时为3-5分钟左右。",
            "gaugeIcon": "https://bj.download.cycore.cn/CSB-decompression-planet-service/e7dcddfe-21ef-435a-94d6-cd789838878a/编组14(5).png",
            "gaugeModuleType": "健康与卫生",
          },
          {
            "segmentName": "初中、小学、高中",
            "gaugeModuleCode": "01",
            "gaugeName": "失眠严重指数量表(ISI)",
            "gaugeId": "298ef94f73b4430bb483ac8629149d34",
            "id": null,
            "gaugeDesc": "《失眠严重指数量表》（Insomnia Severity Index，ISI）主要评估过去一周内个体主观失眠的严重程度，由Morin和Barlow于1993年编制，包括7个项目，得分越高表明失眠程度越严重。该量表适用于一般人群、失眠症及癌症患者，它能够准确区分睡眠良好者与失眠患者，被证明是一种有效的用于失眠筛查及作为检验失眠干预效果的临床评估工具，有较高的信度和效度。本测验对于教师及时了解学生的睡眠状况以及心理健康都非常有价值。",
            "gaugeIcon": "https://bj.download.cycore.cn/CSB-decompression-planet-service/d063c3da-d496-4026-8f52-37671127a0cd/编组14(2).png",
            "gaugeModuleType": "健康与卫生",
          },
          {
            "segmentName": "初中、高中",
            "gaugeModuleCode": "01",
            "gaugeName": "中学生心理健康量表（MSSMHS ）",
            "gaugeId": "1565018325044864",
            "id": null,
            "gaugeDesc": "中国中学生心理健康量表（MSSMHS）是由我国著名心理学家中科院心理所王极盛教授根据我国中学生的文化特性与行为习惯编制的心理健康量表。属于症状取向的心理诊断量表，旨在对中学生的心理问题或心理障碍进行检测。该测试共有60个必答题目，评价10个中学生常见的心理问题，它们分别为强迫症状、偏执、敌对、人际关系敏感、抑郁、焦虑、学习压力感、适应不良、情绪不稳定、心理不平衡。学生完成时间约需20分钟。",
            "gaugeIcon": "https://bj.download.cycore.cn/CSB-decompression-planet-service/d063c3da-d496-4026-8f52-37671127a0cd/编组14(2).png",
            "gaugeModuleType": "健康与卫生",
          },
          {
            "segmentName": "初中、高中",
            "gaugeModuleCode": "02",
            "gaugeName": "悦纳自我",
            "gaugeId": "102a49d062604bfdab415eeae5c6978d",
            "id": null,
            "gaugeDesc": "本量表从自我接纳和自我评价两个维度评估学生的自我悦纳程度，量表中所有题目选项均为5点量表，总分越高说明学生对自己保持着积极的评价态度、能够接纳自己的程度越高。",
            "gaugeIcon": "https://test.download.cycore.cn/CSB-decompression-planet-service/4bd51dc8-2b6f-43df-8077-ce86e5e742cd/编组14.png",
            "gaugeModuleType": "认识自我",
          },
          {
            "segmentName": "初中、小学、高中",
            "gaugeModuleCode": "02",
            "gaugeName": "沟通能力",
            "gaugeId": "5a0823f8ff2c44a99e031d5682088ad7",
            "id": null,
            "gaugeDesc": "本量表从耐心倾听、积极回应、应对分歧、控制情绪和肢体语言五个维度评估学生的沟通能力，量表中所有题目选项均为5点量表，总分越高说明学生的沟通能力越强。",
            "gaugeIcon": "https://test.download.cycore.cn/CSB-decompression-planet-service/2b29962b-ef2c-41e3-afb7-9fb23920fb9e/编组14(4).png",
            "gaugeModuleType": "人际交往",
          },
          {
            "segmentName": "初中、高中",
            "gaugeModuleCode": "02",
            "gaugeName": "新学期适应",
            "gaugeId": "4c0dfb63491742b58913636465ff4e94",
            "id": null,
            "gaugeDesc": "本量表从环境、人际、学习和心理四个维度评估学生在新的学习阶段的适应情况，量表中所有题目选项均为5点量表，总分越高说明学生的适应情况越好。",
            "gaugeIcon": "https://test.download.cycore.cn/CSB-decompression-planet-service/1427d073-42f7-44d9-9133-8308b73ac744/编组14(3).png",
            "gaugeModuleType": "社会与适应",
          },
          {
            "segmentName": "初中、高中",
            "gaugeModuleCode": "02",
            "gaugeName": "科学用脑",
            "gaugeId": "76966d6250c9471bb6655c272a925be8",
            "id": null,
            "gaugeDesc": "本量表从乐于动脑、勤于健脑、专注用脑及用脑时限四个维度来评估学生科学用脑的状态，量表中所有题目选项均为5点量表，总分越高说明学生科学用脑的意识更高。",
            "gaugeIcon": "https://bj.download.cycore.cn/CSB-decompression-planet-service/d063c3da-d496-4026-8f52-37671127a0cd/编组14(2).png",
            "gaugeModuleType": "学会学习",
          },
          {
            "segmentName": "初中、小学、高中",
            "gaugeModuleCode": "02",
            "gaugeName": "保卫校园",
            "gaugeId": "aa5dd77a2c094819b2184550baf689fd",
            "id": null,
            "gaugeDesc": "本量表从学生对校园欺凌的认识、欺凌行为的认识、近期参与欺凌的程度及看见欺凌的行为反应四个方面综合评估学生对校园欺凌的整体认识水平。量表中所有题目选项均为5点计分，总分越高说明学生校园欺凌的防范意识越强。",
            "gaugeIcon": "https://bj.download.cycore.cn/CSB-decompression-planet-service/fd3c47b5-2a7e-4810-b39d-f23ebfb005b4/编组16(2).png",
            "gaugeModuleType": "人际交往",
          },
          {
            "segmentName": "初中、小学、高中",
            "gaugeModuleCode": "02",
            "gaugeName": "掌控情绪",
            "gaugeId": "697268ad18984002a3b5869ef54c6609",
            "id": null,
            "gaugeDesc": "本量表评估学生对自我情绪的调节和掌控能力，量表中所有题目选项均为4点计分，通过学生对自己日常生活中遭遇负性事件时的情绪调节状况，了解学生是否具备较好的情绪调节和掌控能力。总分越高说明情绪调节和掌控能力越差。",
            "gaugeIcon": "https://bj.download.cycore.cn/CSB-decompression-planet-service/e3d121b0-b8c1-4411-8be6-4fe89a1d09c4/编组16.png",
            "gaugeModuleType": "情绪发展",
          },
          {
            "segmentName": "初中、小学、高中",
            "gaugeModuleCode": "02",
            "gaugeName": "兴趣知多少",
            "gaugeId": "da5a580f041a4265acd28494f7bb0636",
            "id": null,
            "gaugeDesc": "本量表评估学生的兴趣探索状态，量表中所有题目选项均为4点计分，通过引导学生对自己兴趣状态的了解与思考，帮助学生更主动、积极的对自己的兴趣、爱好进行探索。总分越高说明学生兴趣探索程度越高。",
            "gaugeIcon": "https://bj.download.cycore.cn/CSB-decompression-planet-service/ccfe09a8-ace7-47c2-ab21-a4b4f985af2a/编组14(4).png",
            "gaugeModuleType": "升学择业",
          },
          {
            "segmentName": "初中、小学、高中",
            "gaugeModuleCode": "02",
            "gaugeName": "生命之花",
            "gaugeId": "c89739107ae6427f9f6f39fbfc11ad0a",
            "id": null,
            "gaugeDesc": "本量表从生活态度、生活目标、生活自主、生命价值和幸福体验五个维度评估学生的生命意义感，量表中所有题目选项均为5点量表，总分越高说明学生的生命意义感越强。",
            "gaugeIcon": "https://bj.download.cycore.cn/CSB-decompression-planet-service/d063c3da-d496-4026-8f52-37671127a0cd/编组14(2).png",
            "gaugeModuleType": "社会与适应",
          },
          {
            "segmentName": "初中、小学、高中",
            "gaugeModuleCode": "02",
            "gaugeName": "时间管理",
            "gaugeId": "6f43b61a0cc24e18be05d41bbe032074",
            "id": null,
            "gaugeDesc": "本量表评估学生的时间管理能力水平，量表中所有题目选项均为4点计分，通过学生对自己日常学习生活中的时间分配及利用情况，了解学生是否具备较好的时间管理能力。总分越高说明学生时间管理能力越差。",
            "gaugeIcon": "https://bj.download.cycore.cn/CSB-decompression-planet-service/e7dcddfe-21ef-435a-94d6-cd789838878a/编组14(5).png",
            "gaugeModuleType": "学会学习",
          },
          {
            "segmentName": "初中、高中",
            "gaugeModuleCode": "02",
            "gaugeName": "思维定势",
            "gaugeId": "e2479e6ffe22415bb7b8a8c828954127",
            "id": null,
            "gaugeDesc": "本量表从书本定势、权威定势、从众定势、经验定势及打破思维定势的意识5个方面综合评估学生打破思维定势的意识和能力，量表中所有题目选项均为5点量表，总分越高说明学生打破思维定势的意识和能力越强。",
            "gaugeIcon": "https://bj.download.cycore.cn/CSB-decompression-planet-service/ccfe09a8-ace7-47c2-ab21-a4b4f985af2a/编组14(4).png",
            "gaugeModuleType": "学会学习",
          },
          {
            "segmentName": "初中、高中",
            "gaugeModuleCode": "02",
            "gaugeName": "适应变化",
            "gaugeId": "5c7c14d9bd3a464c973717243ca24b16",
            "id": null,
            "gaugeDesc": "本量表从情绪适应、学习适应、人际适应和生活适应四个方面综合评估学生的适应能力。量表所有题目均为5点计分，得分越高表示学生的适应能力越强。",
            "gaugeIcon": "https://bj.download.cycore.cn/CSB-decompression-planet-service/985d7a7d-eca9-4dcc-a0e7-4ec647a519f3/编组16(3).png",
            "gaugeModuleType": "社会与适应",
          },
          {
            "segmentName": "初中、小学、高中",
            "gaugeModuleCode": "02",
            "gaugeName": "目标管理",
            "gaugeId": "85a7acb327894fffb784b2695a6d74f4",
            "id": null,
            "gaugeDesc": "本量表从目标意向、目标制定、目标执行、目标监督和长期目标五个方面综合评估学生的目标管理能力。量表所有题目均为5点计分，得分越高表示学生的目标管理能力越强。",
            "gaugeIcon": "https://bj.download.cycore.cn/CSB-decompression-planet-service/e7dcddfe-21ef-435a-94d6-cd789838878a/编组14(5).png",
            "gaugeModuleType": "升学择业",
          },
          {
            "segmentName": "初中、小学、高中",
            "gaugeModuleCode": "02",
            "gaugeName": "情绪管理",
            "gaugeId": "0db324d671f844109a19b93a7086639e",
            "id": null,
            "gaugeDesc": "本量表从情绪觉察、情绪理解、情绪运用、情绪表现和情绪调控五个方面综合评估学生的情绪管理能力。量表所有题目均为5点计分，得分越高表示学生的情绪管理能力越强。",
            "gaugeIcon": "https://bj.download.cycore.cn/CSB-decompression-planet-service/74a20166-25f6-489f-99c0-04b6347823ca/编组14(3).png",
            "gaugeModuleType": "情绪发展",
          },
          {
            "segmentName": "初中、高中",
            "gaugeModuleCode": "02",
            "gaugeName": "我能自控",
            "gaugeId": "1e7e4cbd43ef48dcb68a52038deb5e5f",
            "id": null,
            "gaugeDesc": "本量表从学习行为习惯、冲动控制、健康与生活习惯五个方面综合评估学生的自我控制能力。量表所有题目均为5点计分，得分越高表示学生的自我控制能力越强、自律意识越高。",
            "gaugeIcon": "https://bj.download.cycore.cn/CSB-decompression-planet-service/d063c3da-d496-4026-8f52-37671127a0cd/编组14(2).png",
            "gaugeModuleType": "学会学习",
          },
          {
            "segmentName": "初中、高中",
            "gaugeModuleCode": "02",
            "gaugeName": "社会支持",
            "gaugeId": "f75c7655c6f4478482cbe401ffb47c8d",
            "id": null,
            "gaugeDesc": "本量表从主观支持、客观支持、支持利用度三个方面综合评估学生感受到的社会支持程度。量表所有题目均为5点计分，得分越高表示学生感受到的社会支持越多。",
            "gaugeIcon": "https://bj.download.cycore.cn/CSB-decompression-planet-service/03b70af4-2ac5-4aba-ae27-1f2a05724ee6/编组14.png",
            "gaugeModuleType": "人际交往",
          },
          {
            "segmentName": "初中、小学、高中",
            "gaugeModuleCode": "02",
            "gaugeName": "职业价值观",
            "gaugeId": "968a49aff5b14844a1c9bc333665cf7b",
            "id": null,
            "gaugeDesc": "本量表通过10道有趣的场景选择题目，通过学生的个性选择，帮助学生了解自己的职业价值观念。",
            "gaugeIcon": "https://bj.download.cycore.cn/CSB-decompression-planet-service/ccfe09a8-ace7-47c2-ab21-a4b4f985af2a/编组14(4).png",
            "gaugeModuleType": "升学择业",
          },
          {
            "segmentName": "初中、小学、高中",
            "gaugeModuleCode": "02",
            "gaugeName": "应对变化",
            "gaugeId": "c7f40371ed3146f0bb4042c0940d920f",
            "id": null,
            "gaugeDesc": "本量表从创新思维、共情理解、追寻意义、自我管理和团队精神五个方面综合评估学生面对未知变化的应对能力。量表所有题目均为5点计分，得分越高表示学生的应对变化能力越强。",
            "gaugeIcon": "https://bj.download.cycore.cn/CSB-decompression-planet-service/e3d121b0-b8c1-4411-8be6-4fe89a1d09c4/编组16.png",
            "gaugeModuleType": "社会与适应",
          },
          {
            "segmentName": "初中、小学、高中",
            "gaugeModuleCode": "02",
            "gaugeName": "心理弹性",
            "gaugeId": "b5721c02554b4c6b8d71b1d1cc9b1439",
            "id": null,
            "gaugeDesc": "本量表从目标专注、情绪控制、积极认知、家庭支持和人际协助五个方面综合评估学生的心理弹性。量表所有题目均为5点计分，得分越高表示学生的心理弹性越好，应对挫折困难的能力越强。 ",
            "gaugeIcon": "https://bj.download.cycore.cn/CSB-decompression-planet-service/03b70af4-2ac5-4aba-ae27-1f2a05724ee6/编组14.png",
            "gaugeModuleType": "社会与适应",
          },
          {
            "segmentName": "初中、高中",
            "gaugeModuleCode": "02",
            "gaugeName": "思维培养",
            "gaugeId": "58f7bb33c09645ea9732a6d2836fcd6e",
            "id": null,
            "gaugeDesc": "本量表通过10道有关成长型思维和固定型思维的题目综合评估学生的思维模式。量表所有题目均为5点计分，得分越高表示学生更偏向成长型思维，反之，说明学生更偏向固定型思维。",
            "gaugeIcon": "https://bj.download.cycore.cn/CSB-decompression-planet-service/74a20166-25f6-489f-99c0-04b6347823ca/编组14(3).png",
            "gaugeModuleType": "社会与适应",
          },
          {
            "segmentName": "初中、高中",
            "gaugeModuleCode": "02",
            "gaugeName": "人际边界",
            "gaugeId": "f7132435a0d249efacb38d8954a83716",
            "id": null,
            "gaugeDesc": "本量表从保护隐私、懂得拒绝、拯救他人、越界玩笑和过度依赖五个方面综合评估学生的人际边界塑造能力。量表所有题目均为5点计分，得分越高表示学生的人际边界塑造能力越强。",
            "gaugeIcon": "https://bj.download.cycore.cn/CSB-decompression-planet-service/03b70af4-2ac5-4aba-ae27-1f2a05724ee6/编组14.png",
            "gaugeModuleType": "人际交往",
          },
          {
            "segmentName": "初中、高中",
            "gaugeModuleCode": "02",
            "gaugeName": "青少年心理韧性量表",
            "gaugeId": "9cc5d5b95273458ebca8dbf024ede76b",
            "id": null,
            "gaugeDesc": "青少年心理韧性量表（RSCA）由胡月琴、甘怡群（2008）编制。该量表包括目标专注、情绪控制、积极认知、家庭支持、人际支持五个因子分别表示青少年在逆境情境下认知、情绪、行为以及所处的环境时对帮助其抵御逆境、获得良好适应的有效性。得分越高说明该项目上的心理弹性水平越高。",
            "gaugeIcon": "https://bj.download.cycore.cn/CSB-decompression-planet-service/e7dcddfe-21ef-435a-94d6-cd789838878a/编组14(5).png",
            "gaugeModuleType": "社会与适应",
          },
          {
            "segmentName": "初中、高中",
            "gaugeModuleCode": "02",
            "gaugeName": "考试焦虑量表(TAS)",
            "gaugeId": "32294cf4227d464784bb448ec7631e72",
            "id": null,
            "gaugeDesc": "《考试焦虑量表》（TAS）由美国临床心理学家Irwin G. Sarason教授于1978年编制完成，是目前国际上广泛使用的最著名的考试焦虑量表之一。TAS中文版是参考了王才康的1999年译本，由 Insight Group 进一步编制确定的。一般认为，TAS测量的是考试焦虑的特质方面，即哪些人容易感到考试焦虑。测验适合中学生及以上人群，大约需要8分钟。",
            "gaugeIcon": "https://bj.download.cycore.cn/CSB-decompression-planet-service/fd3c47b5-2a7e-4810-b39d-f23ebfb005b4/编组16(2).png",
            "gaugeModuleType": "学会学习",
          },
          {
            "segmentName": "初中、小学、高中",
            "gaugeModuleCode": "02",
            "gaugeName": "学习动机量表",
            "gaugeId": "182dd055f3fc4ee69df93cfb482fe4bd",
            "id": null,
            "gaugeDesc": "《学习动机量表》是Amabile(1994)等人编制，池丽萍、辛自强（2006）年修订的。该量表由30个项目组成，包括内生动机和外生动机两个分量表。量表采用4级评分，从“很不同意”到“很同意”，得分越高表示动机水平越强。该量表有较高的信效度。该量表也适合团体施测。",
            "gaugeIcon": "https://bj.download.cycore.cn/CSB-decompression-planet-service/d063c3da-d496-4026-8f52-37671127a0cd/编组14(2).png",
            "gaugeModuleType": "学会学习",
          },
          {
            "segmentName": "初中、高中",
            "gaugeModuleCode": "02",
            "gaugeName": "青少年学习倦怠量表",
            "gaugeId": "22e97af3ae5f495da60a586752596fd0",
            "id": null,
            "gaugeDesc": "《青少年学习倦怠量表》是在 Maslach工作倦怠问卷基础上，由吴艳和戴晓阳于2007年编制修订而成的，可对青少年的学习倦怠情况进行评估。评估内容涉及个体身心耗损、对学业的态度以及学习低成就感几方面的情况，有较高的信度和效度。本测验对于教师及时正确地了解孩子的学习状况，以及对中学生学习生活进行干预都非常有价值。",
            "gaugeIcon": "https://bj.download.cycore.cn/CSB-decompression-planet-service/74a20166-25f6-489f-99c0-04b6347823ca/编组14(3).png",
            "gaugeModuleType": "学会学习",
          }
        ],
        "maxOptionNum": null
      };
      this.allList = res.dataList;
      this.listData = this.allList.slice(0, 12);
      this.listData = this.listData.map(x => ({
        ...x,
        segmentName: x.segmentName ? x.segmentName.replace(/,/g, '、') : null,
      }));
      this.total = res.totalCount;
      this.resquestEnd = true;
    },
    /** 分页 */
    handleCurrent (val) {
      this.page.pageNum = val;
      if (val === 1) {
        this.listData = this.allList.slice(0, 12);
      } else {
        this.listData = this.allList.slice(12 * (this.page.pageNum - 1), 12 * this.page.pageNum);
      }
    },
    /** 详情 */
    clickDetail (row) {

    },
    /** 发布 @type 1 发布 2 创建 @val 发布任务额相关参数 @orgin 1 量表 2 任务*/
    issue (type, val) {

    },
  },
};
</script>

<style scoped lang="scss">
.content {
  width: 100%;
  background: #fff;
  min-height: calc(100vh - 55px);
  border-radius: 4px;
  flex-direction: column;
}
.content-box {
  width: 100%;
  padding: 12px 24px 16px;
  .icon {
    cursor: pointer;
    &:hover {
      .el-icon-search {
        color: #368fff;
      }
    }
  }
}
.title-label {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 0 24px;
  font-size: 16px;
  border-bottom: 1px solid #f0f1f4;
  height: 55px;
  line-height: 55px;
  span {
    font-weight: bold;
  }
  .el-button {
    text-align: center;
    width: 88px;
    font-size: 14px;
    padding: 8px 0;
  }
}
.el-form {
  margin-bottom: 5px;
  .el-form-item {
    margin-bottom: 7px;
    &:last-child {
      margin-left: 3px;
      margin-right: 0;
    }
  }
}
.w140 {
  width: 140px;
}
.w185 {
  width: 185px;
}
.mr0 {
  margin-right: 0;
}
.lists {
  margin-bottom: 7px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  .list-item {
    margin-right: 38px;
    position: relative;
    width: 273px;
    height: 300px;
    background: #ffffff;
    border-radius: 8px;
    margin-bottom: 24px;
    border: 1px solid #f0f0f0;
    &:hover {
      box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.07);
      .title {
        color: #368fff;
      }
    }
    &:nth-child(3n) {
      margin-right: 0;
    }
    .title-icon {
      position: absolute;
      left: -1px;
      top: -1px;
      font-size: 12px;
      height: 24px;
      line-height: 24px;
      z-index: 2;
    }

    .all {
      color: #fff;
      display: inline-block;
      padding: 0px 11px;
      height: 100%;
      border-radius: 8px 0 8px 0;
      background: rgba(0, 0, 0, 0.3);
    }
    .bluetext {
      // color: #fff;
      // display: inline-block;
      // padding: 0px 11px;
      // height: 100%;
      // border-radius: 8px 0 8px 0;
      // background: rgba(0, 0, 0, 0.3);
    }
    .imgbox {
      width: 273px;
      height: 140px;
      border-radius: 8px 8px 0 0;
      position: absolute;
      top: -1px;
      left: -1px;
      .item-img {
        width: 273px;
        height: 140px;
        border-radius: 8px 8px 0 0;
      }
      .title-icon-right {
        position: absolute;
        width: 100%;
        height: 40px;
        left: 0;
        bottom: 0;
        font-size: 12px;
        background: rgba(0, 0, 0, 0.2);
        color: #fff;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
        z-index: 2;
      }
    }

    .img-text {
      width: 100%;
      height: 140px;
      padding: 0 28px;
      // position: absolute;
      // top: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0 28px;

      .img-text-title {
        // padding: 44px 19px;
        font-size: 20px;
        font-weight: bold;
        line-height: 26px;
        color: #fff;
        word-wrap: break-word;
        word-break: normal;
        text-align: center;
        z-index: 2;
      }
    }
    .title {
      padding: 16px;
      color: #000000;
      font-size: 16px;
      font-weight: bold;
      cursor: pointer;
    }
    .segment {
      margin-bottom: 12px;
      padding: 0 16px 0px;
      font-size: 12px;
      span {
        margin-right: 8px;
      }
    }
    .title-cont {
      margin-bottom: 20px;
      padding: 0 16px 0px;
      line-height: 20px;
      font-size: 12px;
      display: inline-block;
      height: 40px;
      color: #8c8c8c;
      word-wrap: break-word;
      word-break: normal;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .button {
      text-align: center;
    }
    .priamry {
      width: 88px;
    }
  }
}
.jyxq-no-data {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin: 44px auto 0;
  text-align: center;
  div {
    color: #8c8c8c;
    font-size: 14px;
  }
}
</style>
